export default function parseCategories(data) {
    var _a, _b;
    const categories = (_b = (_a = data === null || data === void 0 ? void 0 : data.autocomplete) === null || _a === void 0 ? void 0 : _a.productCategories) === null || _b === void 0 ? void 0 : _b.edges;
    if ((categories === null || categories === void 0 ? void 0 : categories.length) === 0)
        return [];
    return categories === null || categories === void 0 ? void 0 : categories.map(({ node }) => ({
        id: node.id,
        type: node === null || node === void 0 ? void 0 : node.type,
        typeLabelPL: node === null || node === void 0 ? void 0 : node.typeLabelPL,
        typeLabelEN: node === null || node === void 0 ? void 0 : node.typeLabelEN,
        slug: node === null || node === void 0 ? void 0 : node.typeLabelEN.toLowerCase().replace(/ /g, '-'),
        productsCount: node === null || node === void 0 ? void 0 : node.productsCount,
        typeIcon: node === null || node === void 0 ? void 0 : node.typeIcon,
        displayOrder: node === null || node === void 0 ? void 0 : node.displayOrder,
        filtersAvailable: node === null || node === void 0 ? void 0 : node.filtersAvailable,
        hasName: node === null || node === void 0 ? void 0 : node.hasName,
        hasComposition: node === null || node === void 0 ? void 0 : node.hasComposition,
        hasComponentSize: node === null || node === void 0 ? void 0 : node.hasComponentSize,
        hasSupplier: node === null || node === void 0 ? void 0 : node.hasSupplier,
        hasProductDescription: node === null || node === void 0 ? void 0 : node.hasProductDescription,
        hasWidth: node === null || node === void 0 ? void 0 : node.hasWidth,
        hasZipperType: node === null || node === void 0 ? void 0 : node.hasZipperType,
        hasUpperSliderType: node === null || node === void 0 ? void 0 : node.hasUpperSliderType,
        hasUnderSliderType: node === null || node === void 0 ? void 0 : node.hasUnderSliderType,
        variantHasColor: node === null || node === void 0 ? void 0 : node.variantHasColor,
        variantHasChainColor: node === null || node === void 0 ? void 0 : node.variantHasChainColor,
        variantHasTapeColor: node === null || node === void 0 ? void 0 : node.variantHasTapeColor,
        variantHasSliderColor: node === null || node === void 0 ? void 0 : node.variantHasSliderColor,
        variantHasSize: node === null || node === void 0 ? void 0 : node.variantHasSize,
        hasGrammage: node === null || node === void 0 ? void 0 : node.hasGrammage,
        hasProducerCode: node === null || node === void 0 ? void 0 : node.hasProducerCode,
        hasYardage: node === null || node === void 0 ? void 0 : node.hasYardage,
        colorAutoCalculationMethod: node === null || node === void 0 ? void 0 : node.colorAutoCalculationMethod,
        nameAutoCalculationMethod: node === null || node === void 0 ? void 0 : node.nameAutoCalculationMethod,
    }));
}
